// Where to attach an overlay triggered from inside a dialog — Bootstrap tooltips and popovers,
// which default to `document.body`, and StyledSelect's portalled menu.
//
// A body-appended element cannot paint above a `<dialog>` opened with `showModal()`: the top
// layer sits above the whole stacking context, so no z-index reaches it. Measured on
// /quote_groups/27 — a tooltip inside an open dialog rendered at z-index 1095 but hit-tested to
// the dialog, visibly clipped behind the card.
//
// `dialog` rather than `dialog[open]`: a Stimulus controller can connect before the dialog is
// opened, since a React modal mounts its content and calls `showModal()` in an effect.
export function overlayContainer(element: Element | null | undefined): HTMLElement {
  return element?.closest('dialog') ?? document.body
}
